import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../shadcn-ui/card';
import { ChevronRight } from 'lucide-react';
import { Separator } from '../shadcn-ui/separator';

const StorageLotCard = ({ lot }) => {
  return (
    <Link to={`/storage-lots/${lot._id}`}>
      <Card className="flex items-center justify-between p-3">
        <div className="flex flex-1 flex-col overflow-hidden">
          <div className="font-medium">{lot?.lotname}</div>
          <div className="">{lot?.estate_name?.name}</div>
          <div className="flex items-center gap-2 text-sm tracking-tight">
            {`${lot?.drying_end_day || 0} days since drying end`}
          </div>

          {/* Total weight and Available weight --- based on condition show it */}
          <div className="flex items-center gap-2 text-xs tracking-tight">
            <div className="font-medium">
              Total weight: <span>{lot?.total_weight} kg</span>
            </div>
            <Separator orientation="vertical" className="h-4 w-px bg-gray-600" />
            <div className="font-medium">
              {/* Available weight: <span>{lot?.total_weight - (lot?.consumption_weight || 0)} kg</span> */}
              Available weight:{' '}
              <span>{(Number(lot?.total_weight || 0) - Number(lot?.consumption_weight || 0)).toFixed(2)} kg</span>
            </div>
          </div>
        </div>
        <button className="mx-1 min-w-5 flex-shrink-0">
          <ChevronRight className="h-5 w-5" />
        </button>
      </Card>
    </Link>
  );
};

export default StorageLotCard;
